const TransactionType = {
	Acquisition: 1,
	Disposition: 2,
	Transfer: 3,
	Destroy: 4,
	Loss: 5,
	Reservation: 6,
	Rental: 7,

	1: 'Acquisition',
	2: 'Disposition',
	3: 'Transfer',
	4: 'Destroy',
	5: 'Loss',
	6: 'Reservation',
	7: 'Rental',
};

export default TransactionType;